/**
 * The password rule of the sign-up and the password reset forms.
 *
 * It must accept exactly what the server accepts, or a form takes a password the server then refuses. The server's
 * rule is `AdornisUser.passwordValidator` (@adornis/users, db/validators.js): at least 8 characters, a lowercase
 * letter, an uppercase letter, a digit and a character that is not a letter or digit. (Its list of special characters
 * contains a range that also matches digits and capitals, so the list itself restricts nothing.)
 * If the library's rule ever changes, this has to change with it.
 */

export const PASSWORD_MIN_LENGTH = 8;

export type PasswordRequirement = 'length' | 'lowercase' | 'uppercase' | 'digit' | 'special';

/** The requirements `password` does not meet yet, in the order they are listed to the user. */
export const getMissingPasswordRequirements = (password: string): PasswordRequirement[] => {
  const missing: PasswordRequirement[] = [];
  if (password.length < PASSWORD_MIN_LENGTH) missing.push('length');
  if (!/[a-z]/.test(password)) missing.push('lowercase');
  if (!/[A-Z]/.test(password)) missing.push('uppercase');
  if (!/[0-9]/.test(password)) missing.push('digit');
  if (!/[^a-zA-Z0-9]/.test(password)) missing.push('special');
  return missing;
};

export const isValidPassword = (password: string) => getMissingPasswordRequirements(password).length === 0;
